/* Luvie Theme — Main JS */

class LuvieTheme {
  constructor() {
    this.overlay = document.getElementById('overlay');
    this.init();
  }

  init() {
    this.mobileNav();
    this.faqAccordion();
    this.productDetails();
    this.productGallery();
    this.variantSelectors();
    this.stickyATC();
    this.cartCountInit();
    this.quantityButtons();
  }

  mobileNav() {
    const openBtn = document.querySelector('.mobile-menu-btn');
    const nav = document.querySelector('.mobile-nav');
    const closeBtn = document.querySelector('.mobile-nav-close');
    if (!openBtn || !nav) return;

    const open = () => {
      nav.classList.add('open');
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      nav.classList.remove('open');
      if (!document.querySelector('.cart-drawer.open')) {
        this.overlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    };

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    this.overlay.addEventListener('click', close);
  }

  faqAccordion() {
    document.querySelectorAll('.faq-q').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.faq-item');
        const answer = item.querySelector('.faq-a');
        const isOpen = item.classList.contains('open');

        document.querySelectorAll('.faq-item.open').forEach(el => {
          el.classList.remove('open');
          el.querySelector('.faq-a').style.maxHeight = '0';
        });

        if (!isOpen) {
          item.classList.add('open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  productDetails() {
    document.querySelectorAll('.product-detail-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.product-detail-item');
        const content = item.querySelector('.product-detail-content');
        const isOpen = item.classList.contains('open');
        item.classList.toggle('open', !isOpen);
        content.style.maxHeight = isOpen ? '0' : content.scrollHeight + 'px';
      });
    });
  }

  productGallery() {
    const thumbs = document.querySelectorAll('.product-thumb');
    const mainImg = document.querySelector('.product-gallery-main img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.querySelector('img')?.getAttribute('src');
        if (src) mainImg.src = src;
      });
    });
  }

  variantSelectors() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.option-btn');
      if (!btn) return;
      btn.closest('.option-swatches')
        .querySelectorAll('.option-btn')
        .forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  }

  stickyATC() {
    const bar = document.querySelector('.sticky-atc');
    const trigger = document.querySelector('.product-atc-btn');
    if (!bar || !trigger) return;

    new IntersectionObserver(
      ([entry]) => bar.classList.toggle('visible', !entry.isIntersecting),
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    ).observe(trigger);
  }

  cartCountInit() {
    this.refreshCartCount();
  }

  async refreshCartCount() {
    try {
      const { item_count } = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = item_count;
        el.classList.toggle('visible', item_count > 0);
      });
    } catch (_) {}
  }

  quantityButtons() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.qty-btn[data-action]');
      if (!btn) return;
      const wrap = btn.closest('[data-qty-wrap]');
      if (!wrap) return;
      const display = wrap.querySelector('.qty-val');
      if (!display) return;
      let val = parseInt(display.textContent || '1', 10);
      if (btn.dataset.action === 'increase') val++;
      if (btn.dataset.action === 'decrease' && val > 1) val--;
      display.textContent = val;
      const hiddenInput = wrap.querySelector('input[name="quantity"]');
      if (hiddenInput) hiddenInput.value = val;
    });
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

document.addEventListener('DOMContentLoaded', () => {
  window.luvieTheme = new LuvieTheme();
});
